module.exports = __webpack_public_path__ + "static/media/Facebook.74687a9b.svg";